<template>
  <span class="image">
    <picture v-if="!product.rotate_for_insert">
      <img :src="product.default_bottle_image_url" alt="" height="220" />
    </picture>
    <picture v-else>
      <source :srcset="product.bottle_image_optimized_url" type="image/webp" />
      <source :srcset="product.bottle_image_url" type="image/jpeg" />
      <img :src="product.bottle_image_url" alt="" height="220" />
    </picture>
  </span>
</template>

<script>
export default {
  name: 'NarrativeProductCardImage',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
}
</script>
